// extracted by mini-css-extract-plugin
export default {"rightIcon":"RecentsByConnectorCard_rightIcon__K4Dk-"};